module.exports = __webpack_public_path__ + "dimer/static/img/awards.8a0a17a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/awards.jpg
// module id = TqdY
// module chunks = 0